export default "__VITE_PUBLIC_ASSET__fee01906__"